module.exports = __webpack_public_path__ + "img/setImg.e376e224.png";